import Vue from "vue"
import Vuex from "vuex"
import getters from "./getters"
import createPersistedState from "vuex-persistedstate"
import app from "./modules/app"
import member from "./modules/member"
import wechat from "./modules/wechat"
import site from "./modules/site"
import cart from "./modules/cart"
import order from "./modules/order"

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        member,
        site,
        cart,
        order,
		wechat
    },

    getters,

    plugins: [
        createPersistedState({
            storage: window.localStorage,
            reducer(val) {
                const { app, site, order } = val
                // systemConfig 已存储在 sessionStorage，不重复写入 localStorage
                const { systemConfig, ...persistedSite } = site
                return { app, site: persistedSite, order }
            }
        })
    ]
})

export default store
